import React from "react";
import renderHTML from "react-render-html";
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon
} from "react-share";
import { prettyNames, wordArticles, colors } from "../../utils";

import "./header.css";
import "../../social.css";
import "./standfirst.css";

const daysToElections = Math.ceil(
  (new Date("2018-03-04") - new Date()) / (1000 * 3600 * 24)
);
// const selectedAreas = shuffle(areas).slice(0, 3);
const Standfirst = props => {
  if (!props.articles.length) {
    return null;
  }
  const { slugsSortedList } = props;
  // console.log(slugsSortedList);
  const firstArea = slugsSortedList[0][0];
  const secondArea = slugsSortedList[1][0];
  //const selectedAreas = areas.filter(d => (d !== firstArea && d !== secondArea));
  return (
    <section className="standfirst parallax-layer parallax-layer-back">
      {daysToElections > 0 && (
        <h1>
          Il <b>4 Marzo</b> gli italiani vanno a votare per eleggere un nuovo
          governo. Manca{daysToElections > 1 ? "no" : ""} solo{" "}
          <b>{daysToElections > 1 ? daysToElections : "un"}</b> giorn{daysToElections >
            1
              ? "i"
              : "o"}.
        </h1>
      )}
      {daysToElections === 0 && (
        <h1>
          <b>Oggi</b> gli italiani vanno a votare per eleggere un nuovo
          governo. Mancano poche ore per scoprire come sono andate queste elezioni.
        </h1>
      )}
      {daysToElections === -1 && (
        <h1><b>Ieri</b> gli italiani sono andati a votare per eleggere il nuovo
        governo. I numeri dicono che non c'&egrave; un governo.</h1>
      )}
      {daysToElections < -1 && (
        <h1>Il <b>4 Marzo</b> gli italiani hanno votato per eleggere il nuovo
          governo. Il <span
            className="party-name"
            style={{ borderColor: colors['m5s'] }}
                      >
            {prettyNames['m5s']}
          </span> &egrave; stato il partito pi&ugrave; votato. Dopo una lunga trattativa il <span
            className="party-name"
            style={{ borderColor: colors['m5s'] }}
                                                                                            >
            {prettyNames['m5s']}
          </span> e la <span
            className="party-name"
            style={{ borderColor: colors['lega'] }}
                       >
            {prettyNames['lega']}
          </span> hanno formato un <i>Governo Giallo-Verde</i>.</h1>
      )}
      <div>
        <h1>
          {/* {props.showingHours > 24
            ? renderHTML("Negli ultimi <b>due</b> giorni")
          : renderHTML("Nelle ultime <b>24</b> ore")}{" "} */}
          Durante il periodo delle elezioni e fino alla nascita del governo
          abbiamo intercettato e visualizzato
          {/* <b>{props.articles.length}</b>  */}
          le news nelle
          discussioni sui social network.
          {/*Le aree politiche di cui si &egrave;
            parlato di pi&ugrave; sono state {wordArticles[firstArea]}{" "}
            <span
            className="party-name"
            style={{ borderColor: colors[firstArea] }}
            >
            {prettyNames[firstArea]}
            </span>{" "}
            e {wordArticles[secondArea]}{" "}
            <span
            className="party-name"
            style={{ borderColor: colors[secondArea] }}
            >
            {prettyNames[secondArea]}
          </span> */}
        </h1>
      </div>

      <div className="main-title">
        <svg
          className="logo"
          id="header-logo-small"
          preserveAspectRatio="xMidYMid meet"
          width="426px"
          height="426px"
          viewBox="0 0 426 426"
        >
          <g
            id="header-logo-small-group"
            transform="translate(0.000000, 84.000000)"
          >
            <rect
              id="header-logo-small-red"
              transform="translate(296.693434, 128.693434) rotate(45.000000) translate(-296.693434, -128.693434) "
              x="205.693434"
              y="37.6934342"
              width="182"
              height="182"
            />
            <rect
              id="header-logo-small-green"
              transform="translate(129.000000, 129.000000) rotate(45.000000) translate(-129.000000, -129.000000) "
              x="38"
              y="38"
              width="182"
              height="182"
            />
          </g>
        </svg>
        <h1>
          <span>
            Faccia a faccia<br />con le elezioni
          </span>
          <div className="social">
            <FacebookShareButton
              url="http://facciafaccia.elezioni.io/"
              quote="Faccia a faccia con le elezioni - Scopri come gli italiani condividono le news sulle elezioni del 4 Marzo"
              hashtag="#Elezioni2018"
              className="share-button"
            >
              <FacebookIcon size={32} round />
            </FacebookShareButton>
            <TwitterShareButton
              url="http://facciafaccia.elezioni.io/"
              title="Faccia a faccia con le elezioni - Scopri come gli italiani condividono le news sulle elezioni del 4 Marzo"
              hashtags={["Elezioni2018"]}
              className="share-button"
            >
              <TwitterIcon size={32} round />
            </TwitterShareButton>
          </div>
        </h1>

        <span className="credits">
          Un progetto di Simone Lippolis e Carlo Zapponi
        </span>
      </div>
    </section>
  );
};

export default Standfirst;



// WEBPACK FOOTER //
// ./src/elezioni/components/Layout/Standfirst.js